import { Award, AlertCircle, TrendingUp, Target, TrendingDown } from 'lucide-react';

export default function KeyMetricsCards({ individualTrends }) {
  const calculateTrend = (data, metric) => {
    if (!data || data.length < 6) return 0;
    const recent = data.slice(-3).reduce((sum, item) => sum + item[metric], 0) / 3;
    const earlier = data.slice(0, 3).reduce((sum, item) => sum + item[metric], 0) / 3;
    return ((recent - earlier) / earlier) * 100;
  };

  if (!individualTrends || individualTrends.length === 0) return null;

  const metrics = [
    { key: 'mood', label: 'Mood', icon: Award, color: 'text-blue-600 bg-blue-50' },
    { key: 'stress', label: 'Stress', icon: AlertCircle, color: 'text-red-500 bg-red-50', invert: true },
    { key: 'energy', label: 'Energy', icon: TrendingUp, color: 'text-green-600 bg-green-50' },
    { key: 'confidence', label: 'Confidence', icon: Target, color: 'text-purple-600 bg-purple-50' }
  ];

  return (
    <div className="bg-white rounded-xl shadow-lg p-4 border border-emerald-100">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {metrics.map(({ key, label, icon: Icon, color, invert }) => {
          const trend = calculateTrend(individualTrends, key);
          const avgValue = individualTrends.reduce((sum, item) => sum + item[key], 0) / individualTrends.length;
          const TrendIcon = trend > 0 ? TrendingUp : TrendingDown;
          const trendColor = (invert ? -trend : trend) > 0 ? 'text-green-600' : 'text-red-500';

          return (
            <div key={key} className="flex items-center gap-3 p-3 rounded-lg border border-gray-100">
              <div className={`p-2 rounded-lg ${color}`}>
                <Icon className="w-4 h-4" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-xs text-gray-500 font-medium">{label}</p>
                <div className="flex items-baseline gap-2">
                  <span className="text-xl font-bold text-gray-900">{avgValue.toFixed(1)}</span>
                  <span className="text-[10px] text-gray-400">/10</span>
                  <span className={`flex items-center text-[10px] font-semibold ${trendColor}`}>
                    <TrendIcon className="w-3 h-3" />
                    {Math.abs(trend).toFixed(0)}%
                  </span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
